import styled from '@emotion/styled'
import { FadeInAndUpTransition } from '@oneToOne/shared/styles'

export const ChatButtonBadge = styled.span`
  background: var(--red3);
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  position: absolute;
  top: -12px;
  left: 42px;
  inset-inline-end: var(--spacing-16);
  color: var(--white);

  & span {
    ${FadeInAndUpTransition}
  }
`
